import { Cookies } from 'react-cookie-consent'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    cookieConsent: Cookies.get('CookieConsent') === 'true',
    localHideCookieConsent: false
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        acceptCookieConsent(state) {
            // Ensure cookie is set when reducer called from thunk
            try { Cookies.set('CookieConsent', 'true') } catch (e) { }
            state.cookieConsent = true
        },
        localHideCookieConsent(state, action) {
            state.localHideCookieConsent = !!(action.payload && action.payload.hide)
        }
    }
})

export const { acceptCookieConsent, localHideCookieConsent } = settingsSlice.actions
export default settingsSlice.reducer

